/**
 * Viewport entrance for heritage showcase (copy, media frame, badge, overlay).
 * prefers-reduced-motion: reveal immediately (no animation).
 */
(function () {
  var SEL = '.heritage-showcase--reveal';

  function revealApi() {
    return window.R3NU && window.R3NU.reveal ? window.R3NU.reveal : null;
  }

  function shouldReveal(section, entry) {
    var api = revealApi();
    if (api) return api.shouldReveal(section, entry);
    return entry && entry.isIntersecting;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function detachListeners(section) {
    if (section._heritageRevealIO) {
      section._heritageRevealIO.disconnect();
      section._heritageRevealIO = null;
    }
    if (section._heritageRevealOnScroll) {
      window.removeEventListener('scroll', section._heritageRevealOnScroll, { capture: true });
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', section._heritageRevealOnScroll);
      }
      section._heritageRevealOnScroll = null;
    }
    if (section._heritageRevealOnResize) {
      window.removeEventListener('resize', section._heritageRevealOnResize);
      section._heritageRevealOnResize = null;
    }
  }

  function reveal(section) {
    section.classList.add('heritage-showcase--revealed');
    detachListeners(section);
  }

  function teardown(section) {
    detachListeners(section);
  }

  function init(section) {
    if (!section || section.dataset.heritageRevealInit) return;
    section.dataset.heritageRevealInit = 'true';

    if (prefersReducedMotion()) {
      reveal(section);
      return;
    }

    if (section.classList.contains('heritage-showcase--revealed')) return;

    var api = revealApi();
    var rootMargin = api ? api.getRootMargin() : '0px 0px 12% 0px';
    var thresholdList = api ? api.buildThresholdList() : [0, 0.1, 0.2, 0.5, 1];

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.target !== section) return;
          if (shouldReveal(section, entry)) reveal(section);
        });
      },
      { threshold: thresholdList, rootMargin: rootMargin }
    );
    io.observe(section);
    section._heritageRevealIO = io;

    function onResize() {
      if (section.classList.contains('heritage-showcase--revealed')) return;
      if (shouldReveal(section, null)) reveal(section);
    }
    section._heritageRevealOnResize = onResize;
    window.addEventListener('resize', onResize, { passive: true });

    function onScrollRaf() {
      if (section.classList.contains('heritage-showcase--revealed')) return;
      requestAnimationFrame(function () {
        if (section.classList.contains('heritage-showcase--revealed')) return;
        try {
          if (section._heritageRevealIO) {
            section._heritageRevealIO.takeRecords().forEach(function (entry) {
              if (entry.target === section && shouldReveal(section, entry)) reveal(section);
            });
          }
        } catch (e) {}
        if (!section.classList.contains('heritage-showcase--revealed') && shouldReveal(section, null)) {
          reveal(section);
        }
      });
    }
    section._heritageRevealOnScroll = onScrollRaf;
    window.addEventListener('scroll', onScrollRaf, { passive: true, capture: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScrollRaf, { passive: true });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (section.classList.contains('heritage-showcase--revealed')) return;
        if (shouldReveal(section, null)) reveal(section);
      });
    });
  }

  function destroy(section) {
    delete section.dataset.heritageRevealInit;
    teardown(section);
  }

  function scan(root) {
    var scope = root || document;
    scope.querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) scan(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t) return;
    var el = t.matches && t.matches(SEL) ? t : t.querySelector(SEL);
    if (el) destroy(el);
  });

  function syncHeritageInView() {
    document.querySelectorAll(SEL).forEach(function (section) {
      if (!section.dataset.heritageRevealInit) return;
      if (section.classList.contains('heritage-showcase--revealed')) return;
      var io = section._heritageRevealIO;
      if (io) {
        try {
          io.takeRecords().forEach(function (entry) {
            if (entry.target === section && shouldReveal(section, entry)) reveal(section);
          });
        } catch (e) {}
      }
      if (section.classList.contains('heritage-showcase--revealed')) return;
      if (shouldReveal(section, null)) reveal(section);
    });
  }

  if (window.r3nuRegisterViewportRecheck) {
    window.r3nuRegisterViewportRecheck(syncHeritageInView);
  }
})();
